<template>
	<div style="display: contents">

		<v-slide-y-transition>
			<v-card-text class="pa-1 px-4" v-if="showFilters">
				<v-container fluid grid-list-sm class="pa-0">
            		<v-subheader class="pl-0">Filtri Avanzati</v-subheader>
					<v-layout row wrap>
						<v-flex xs12 sm6 md4 lg3 
						:class="{'pr-4': $vuetify.breakpoint.smAndUp}">
							<v-autocomplete
								:items="existingFilters"
								v-model="existingFilterSelected"
								label="Seleziona filtro esistente"
								item-text="title"
								item-value="id"
								return-object
								no-data-text="Nessun filtro esistente"
								dense
								@change="changeSelectedFilter"
							></v-autocomplete>
						</v-flex>
						<v-flex xs12 sm6 md4 lg3 :class="{'pr-4': $vuetify.breakpoint.mdAndUp}">
							<v-text-field
								name="input-1"
								label="Nome Filtro"
								v-model="filterName"
								required
								:error-messages="errors.collect('Nome Filtro')"
								v-validate="'required'"
								:data-vv-name="'Nome Filtro'"
							></v-text-field>
						</v-flex>
						<v-flex xs12 sm12 md4 lg3 offset-lg3 pr-4>
							<v-switch
								class="text-xs-center flex margin-auto"
								tabinde="10"
								label="Visibile a tutti"
								v-model="visibleToAll"
								color="amber darken-1"
							></v-switch>
						</v-flex>
					</v-layout>
					<v-layout row wrap>
			          	<v-flex xs12 sm12 md8 lg8 :class="{'pr-4': $vuetify.breakpoint.mdAndUp}">
				          	<v-autocomplete
					          	label="Filtri"
					          	:items="availableFilters"
					          	v-model="availableFilterSelected"
					          	multiple
					          	autocomplete
					          	small-chips
					          	clearable
					          	persistent-hint
					          	return-object
					          	no-data-text="Nessun risultato"
					          	item-text="label"
					          	item-value="key"
					          	dense
						   	></v-autocomplete>
		   	          	</v-flex>
		   	          	<v-flex lg3 md3 xs12 offset-lg1 pr-4>
		   	          		<v-switch
		   	          			class="text-xs-center flex margin-auto"
		   	          			tabinde="10"
		   	          			label="Verifica tutte le condizioni"
		   	          			v-model="model['and_or']"
		   	          			color="amber darken-1"
		   	          		></v-switch>
		   	          	</v-flex>
					</v-layout>

					<v-subheader v-if="availableFilterSelected.length > 0" class="pl-0">Filtri Selezionati</v-subheader>

					<v-layout row wrap>
						<template v-for="(input, i) in availableFilterSelected">

							<template v-if="input.type == 'date'">
								<v-flex :class="defaultClass(input)" :key="i">
									<v-menu
										:ref="input.key + '_from'"
										:close-on-content-click="false"
										v-model="datepicker_menu[input.key + '_from']"
										:return-value.sync="model[input.key].from"
										lazy
										transition="scale-transition"
										offset-y
										full-width
										max-width="290px"
										min-width="290px"
										:nudge-right="40"
										style="width:100%">
										<v-text-field 
											slot="activator"
											:label="input.label"
											append-icon="event"
											readonly
											:value="$eventBusUtility.formatDate(model[input.key].from)"
											class="pr-3"
											hint="Da"
											persistent-hint
										></v-text-field>
										<v-date-picker
											v-model="model[input.key].from"
											no-title
											scrollable
											actions
											color="amber darken-1"
											locale="It"
											@input="$refs[input.key + '_from'][0].save(model[input.key].from)"
											>
										</v-date-picker>
									</v-menu>
								</v-flex>
								<v-flex :class="defaultClass(input)" :key="i">
									<v-menu
										:ref="input.key + '_to'"
										:close-on-content-click="false"
										v-model="datepicker_menu[input.key + '_to']"
										:return-value.sync="model[input.key].to"
										lazy
										transition="scale-transition"
										offset-y
										full-width
										max-width="290px"
										min-width="290px"
										:nudge-right="40"
										style="width:100%"
										>
										<v-text-field
											slot="activator"
											:label="input.label"
											append-icon="event"
											readonly
											:value="$eventBusUtility.formatDate(model[input.key].to)"
											class="pr-3"
											hint="A"
											persistent-hint
										></v-text-field>
										<v-date-picker
											v-model="model[input.key].to"
											color="amber darken-1"
											locale="It"
											@input="$refs[input.key + '_to'][0].save(model[input.key].to)"
											>
										</v-date-picker>
									</v-menu>
								</v-flex>
							</template>

							<template v-else-if="input.type == 'number'">
								<v-flex pr-3 :class="defaultClass(input)" :key="i">
									<v-text-field
										:type="input.type"
										:label="input.label"
										hint="Da"
										persistent-hint
										v-model="model[input.key].from"
									></v-text-field>
								</v-flex>
								<v-flex pr-3 :class="defaultClass(input)" :key="i">
									<v-text-field
										:type="input.type"
										:label="input.label"
										hint="A"
										persistent-hint
										v-model="model[input.key].to"
									></v-text-field>
								</v-flex>
							</template>

							<v-flex v-else-if="input.type == 'boolean'" :class="defaultClass(input)" :key="i">
								<v-switch
                                  class="text-xs-center"
                                  tabindex="10"
                                  :label="input.label"
                                  v-model="model[input.key]"
                                  color="amber darken-1"
                            	></v-switch>
                            </v-flex>

							<v-flex v-else-if="input.type === 'belongsTo' || input.type === 'generalTypes' || input.type === 'morphTo' || input.type === 'belongsToMany' || input.type === 'belongsToThrough'" :class="defaultClass(input)" :key="i">
								<v-autocomplete
									:items="input.options"
									:label="input.label"
									v-model="model[input.key]"
									autocomplete
									clearable
									:multiple="input.multiple"
									:small-chips="input.multiple"
									hide-details
									dense
								></v-autocomplete>
							</v-flex>

							<v-flex v-else :class="defaultClass(input)" :key="i">
								<v-text-field
									:type="input.type ? input.type : 'text'"
									:label="input.label"
									v-model="model[input.key]"
									color="amber darken-1"
								></v-text-field>
							</v-flex>
						</template>
						</v-layout>
					</v-container>

					<v-card-actions v-if="$vuetify.breakpoint.xs" class="pt-0 px-0">
						<v-spacer></v-spacer>
						<v-btn v-if="showDelete" flat icon @click="deleteFilter()">
							<v-icon color="error">delete</v-icon>
						</v-btn>
						<v-btn flat icon @click="saveFilter('new')">
							<v-icon color="amber">add</v-icon>
						</v-btn>
						<v-btn flat icon @click="empties()">
							<v-icon color="red">close</v-icon>
						</v-btn>
						<v-btn v-if="editAndSave" flat icon @click="saveFilter('update')">
							<v-icon color="amber">edit</v-icon>
						</v-btn>
					</v-card-actions>
					<v-card-actions v-else class="pt-0 px-0">
						<v-spacer></v-spacer>
						<v-btn v-if="showDelete" flat color="error" @click="deleteFilter()">Elimina</v-btn>
						<v-btn flat color="amber" @click="saveFilter('new')">Salva come nuovo</v-btn>
						<v-btn flat color="red" @click="empties()">Svuota</v-btn>
						<v-btn v-if="editAndSave" flat color="amber" @click="saveFilter('update')">Modifica e Salva</v-btn>
					</v-card-actions>

				</v-card-text>
			</v-slide-y-transition>
		</div>
	</template>
<script>
import Vue from 'vue'

export default {
	name: 'advanced-filters',
	components: {},
	props: {
		infoAvailableFilters: Array,
		modelDef: String,
		filtered: Boolean,
		showFilters: Boolean,
		getCache: {
			default: true,
			type: Boolean
		}
	},
	data() {
		return {
			existingFilters: [],
			existingFilterSelected: [],
			availableFilters: this.infoAvailableFilters,
			availableFilterSelected: [],
			model: {
				and_or: true
			},
			datepicker_menu: {},
			visibleToAll: false,
			filterName: null,
			presaveFilters: [],
			showDelete: false,
			editAndSave: false,
			fireEvent: false
		}
	},
	watch: {
		existingFilterSelected: {
			handler(val) {
				localStorage.setItem('advanced_filter_' + this.modelDef,
					JSON.stringify(this.existingFilterSelected))
				if (val.id) {
					this.showDelete = this.editAndSave = true
				} else this.showDelete = false
			}
		},
		availableFilterSelected: {
			handler(val, oldVal) {
				if (_.isEmpty(val)) {
					this.$emit('update:filtered', false)
				} else {
					this.$emit('update:filtered', true)
				}

				let keys = {}

				_.forEach(this.availableFilterSelected, value => {
					keys[value.key] = value.type
				})

				_.forEach(this.model, (value, key) => {
					if (key != 'and_or' && !keys[key]) {
						if (Array.isArray(this.model[key])) {
							Vue.set(this.model, key, [])
						} else if (typeof this.model[key] === 'object') {
							Vue.set(this.model, key, {})
						} else if (keys[key] === 'boolean') {
							Vue.set(this.model, key, false)
						} else {
							Vue.set(this.model, key, '')
						}
					}
				})

				localStorage.setItem('availableFilterSelected_' + this.modelDef,
					JSON.stringify(keys))
			}
		},
		model: {
			handler(oldVal, newVal) {
				if (this.fireEvent) {
					this.$eventBusUtility.$emit('filters_' + this.modelDef, this.model)
				}
				this.fireEvent = true
			},
			deep: true
		}
	},

	methods: {
		defaultClass(input) {
			if (typeof input.class === 'undefined') return 'xs12 sm12 md3 lg3 pr-3'
			else return input.class
		},

		deleteFilter() {
			this.axios
				.post('filters/delete', { id: this.existingFilterSelected.id })
				.then(response => {
					// get body data
					this.existingFilters = response.data.data.options
					this.presaveFilters = response.data.data.filters

					this.$store.commit('setSnackbar', {
						timeout: 6000,
						text: 'Filtro eliminato con successo',
						value: true,
						color: 'success'
					})

					this.empties()
				},
				response => {
					// error callback
				})
		},

		empties() {
			this.availableFilterSelected = []
			this.existingFilterSelected = {}
			this.filterName = null
			this.visibleToAll = false
			this.editAndSave = false
			this.model = {}
			this.setModel()
		},

		changeSelectedFilter(event) {
			this.filterName = event.title
			this.availableFilterSelected = []
			//this.$emit('update:filtered', true)

			let currentFilter = _.filter(this.presaveFilters, f => {
				return f.id === event.id
			})

			this.visibleToAll = currentFilter[0].visible_to_all === 1 ? true : false
			Vue.set(this.model,
				'and_or',
				currentFilter[0].and_or === 1 ? true : false)
			Vue.nextTick(() => {
				_.forEach(currentFilter[0].value, (value, key) => {
					Vue.set(this.model, key, value)

					_.forEach(this.availableFilters, object => {
						object.key === key							? this.availableFilterSelected.push(object)							: null
					})
				})
			})
		},

		initialize() {
			this.axios.get('filters/' + this.modelDef).then(response => {
				// get body data
				this.existingFilters = response.data.data.options
				this.presaveFilters = response.data.data.filters
				if (this.getCache) {
					if (
						localStorage.getItem('advanced_filter_' + this.modelDef) !==                null &&              localStorage.getItem('advanced_filter_' + this.modelDef) != '{}'
					) {
						this.existingFilterSelected = JSON.parse(localStorage.getItem('advanced_filter_' + this.modelDef))
						if (!_.isEmpty(this.existingFilterSelected)) {
							this.changeSelectedFilter(this.existingFilterSelected)
							// this.$eventBusUtility.$emit('filters_'+this.modelDef, this.model)
						}
					} else {
						if (
							localStorage.getItem('availableFilterSelected_' + this.modelDef) !== null
						) {
							_.mapKeys(JSON.parse(localStorage.getItem('availableFilterSelected_' + this.modelDef)),
								(value, key) => {
									_.forEach(this.availableFilters, (val, k) => {
										if (val['key'] == key) {
											this.availableFilterSelected.push(val)
										}
									})
								})
						}

						if (
							localStorage.getItem('crud_advancedFilters_' + this.modelDef) !== null
						) {
							Object.assign(this.model,
								JSON.parse(localStorage.getItem('crud_advancedFilters_' + this.modelDef)))
						}
					}
				}
			},
			response => {
				// error callback
			})
		},

		setModel() {
			_.forEach(this.availableFilters, (value, key) => {
				if (value.structure === 'object') {
					Vue.set(this.model, value.key, {})
				} else if (value.structure === 'array') {
					Vue.set(this.model, value.key, [])
				} else {
					Vue.set(this.model, value.key, '')
				}
			})

			Vue.set(this.model, 'and_or', true)
		},

		saveFilter(type) {
			this.$validator.validateAll().then(result => {
				if (!result) {
					return false
				} else {
					let data = {
						title: this.filterName,
						value: this.model,
						visible_to_all: this.visibleToAll,
						and_or: this.model['and_or'],
						model_class: this.modelDef
					}

					let url = 'filters/'
					let filterSnackbarText = 'Filtro creato con successo'

					// If in edit
					if (type === 'update') {
						url = url + this.existingFilterSelected.id
						data.id = this.existingFilterSelected.id
						filterSnackbarText = 'Filtro aggiornato con successo'
					}
					// If in store
					this.axios.post(url, data).then(response => {
						// get body data

						this.$store.commit('setSnackbar', {
							timeout: 6000,
							text: filterSnackbarText,
							value: true,
							color: 'success'
						})

						this.existingFilters = response.data.data.options
						this.presaveFilters = response.data.data.filters
						this.existingFilterSelected = response.data.data.stored_filter
					},
					response => {
						// error callback
					})
				}
			})
		}
	},

	created() {
		this.setModel()
		this.initialize()
	}
}
</script>
